module.exports = __webpack_public_path__ + "img/CIO211_1-1.1e82d4f9.png";